import {useHistory} from "react-router-dom";

function useNavigate() {
    const history = useHistory();

    return {
        goToQuoterInput: () => history.push("/input"),
        goToQuoterResults: () => history.push("/result"),
        goToAssistanceSubmitted: () => history.push("/assistanceSubmitted"),
    }
}

export default useNavigate;
